import React, { useState } from "react";
import { Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react"; // Optional: if you use feather icons

const Header = ({ toggleSidebar }) => {
  const Darkmode = () => {
    document.querySelector("body").classList.toggle("dark-only");
  };

   const [nshow, setNShow] = useState(false);
  function notiopen(){
    setNShow(!nshow);
  }

  const [sshow, setSshow] = useState(false);
  function logoutopen(){
    setSshow(!sshow);
  }
  return (
    <div className="header-wrapper row m-0">

      {/* Search Form */}
      <form className="form-inline search-full col" action="#" method="get">
        <div className="form-group w-100">
          <div className="Typeahead Typeahead--twitterUsers">
            <div className="u-posRelative">
              <input
                className="demo-input Typeahead-input form-control-plaintext w-100"
                type="text"
                placeholder="Search Focus .."
                name="q"
                title=""
                autoFocus
              />
              <div className="spinner-border Typeahead-spinner" role="status">
                <span className="sr-only">Loading...</span>
              </div>
              <i className="close-search">
                <FeatherIcon icon="x" />
              </i>
            </div>
            <div className="Typeahead-menu"></div>
          </div>
        </div>
      </form>

      {/* Logo Section */}
      <div className="header-logo-wrapper col-auto p-0">
        <div className="logo-wrapper">
          <Link to="/"><img className="img-fluid for-light" src="../assets/images/logo/logo_dark.png" alt="logo-light" /></Link>
          <img className="img-fluid for-dark" src="../assets/images/logo/logo.png" alt="logo-dark" />
        </div>
        <div className="toggle-sidebar" onClick={toggleSidebar}>
          <FeatherIcon icon="align-center" />
        </div>
      </div>

      {/* Welcome Section */}
      <div className="left-header col-xxl-5 col-xl-6 col-lg-5 col-md-4 col-sm-3 p-0">
        <div>
          <a className="toggle-sidebar" href="#">
            <i className="iconly-Category icli"></i>
          </a>
          <div className="d-flex align-items-center gap-2">
            <h4 className="f-w-600">Welcome Admin</h4>
          </div>
        </div>
        <div className="welcome-content d-xl-block d-none">
          <span className="text-truncate col-12">
            {/* Here’s what’s happening with your store today. */}
          </span>
        </div>
      </div>

      {/* Navigation Right Section */}
      <div className="nav-right col-xxl-7 col-xl-6 col-md-7 col-8 pull-right right-header p-0 ms-auto">
        <ul className="nav-menus">


          {/* Mode Toggle */}
          <li onClick={() => Darkmode()}>
            <div className="mode">
              <FeatherIcon icon="moon" />
            </div>
          </li>

          {/* Notifications Dropdown */}
          {/* <li className="onhover-dropdown notification-down" onClick={notiopen}>
            <div className="notification-box">
              <FeatherIcon icon="bell" />
              <span className="badge rounded-pill badge-secondary">4</span>
            </div>

            <div className={`onhover-show-div notification-dropdown ${nshow ? "active" : ""}`}>
              <div className="card mb-0">
                <div className="card-header">
                  <div className="common-space">
                    <h4 className="text-start f-w-600">Notifications</h4>
                    <div><span>4 New</span></div>
                  </div>
                </div>
                <div className="card-body">
                  <p>Notification content here...</p>
                </div>
              </div>
            </div>
          </li> */}

          {/* Profile Dropdown */}
          <li className="profile-nav onhover-dropdown" onClick={logoutopen}>
            <div className="media profile-media">
             
              <img src={require('../assets/images/logo/profile.png')} />
              

              {/* <div className="media-body d-xxl-block d-none box-col-none">
                <div className="d-flex align-items-center gap-2">
                  <span>Alex Mora</span>
                  <i className="middle fa fa-angle-down"></i>
                </div>
                <p className="mb-0 font-roboto">Admin</p>
              </div> */}
            </div>
            <ul className={`profile-dropdown onhover-show-div ${sshow ? "active" : ""}`}>
              {/* <li><Link to="/user-profile"><FeatherIcon icon="user" /><span>My Profile</span></Link></li>
              <li><Link to="/letter-box"><FeatherIcon icon="mail" /><span>Inbox</span></Link></li> */}
              <li><Link to="/settings/messagetemplates"><FeatherIcon icon="settings" /><span>Settings</span></Link></li>
              <li><Link className="btn btn-pill btn-outline-primary btn-sm" to="/login">Log Out</Link></li>
            </ul>
          </li>

        </ul>
      </div>
    </div>
  );
};

export default Header;
